import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MedicalCenterProvider } from './context/MedicalCenterContext';
import ProtectedRoute from './routing/ProtectedRoute';
import Layout from './components/layout/Layout';
import { AlertProvider } from './context/AlertContext';
import LoginPage from './pages/auth/LoginPage';
import AcceptInvitationPage from './pages/auth/AcceptInvitationPage';
import MedicalCenterSelectionPage from './pages/medical-centers/MedicalCenterSelectionPage';
import PatientsPage from './pages/patients/PatientsPage';
import EnrollmentsPage from './pages/enrollments/EnrollmentsPage';
import CallSessionsPage from './pages/call-sessions/CallSessionsPage';
import UsersPage from './pages/users/UsersPage';
import AnalyticsPage from './pages/analytics/AnalyticsPage';
import { ROUTES } from './constants/routes';
import { CallSessionProvider } from './context/CallSessionContext';
import CallSessionDetails from './components/call-sessions/CallSessionDetails';

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path={ROUTES.LOGIN}
        element={isAuthenticated ? <Navigate to={ROUTES.MEDICAL_CENTERS} replace /> : <LoginPage />}
      />
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />

      {/* Selection page */}
      <Route
        path={ROUTES.MEDICAL_CENTERS}
        element={
          <ProtectedRoute>
            <Layout><MedicalCenterSelectionPage /></Layout>
          </ProtectedRoute>
        }
      />

      {/* Nested, RESTful routes per medical center */}
      <Route
        path={ROUTES.MEDICAL_CENTER()}
        element={
          <ProtectedRoute>
            <Layout><Outlet /></Layout>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="patients" replace />} />
        <Route path="patients" element={<PatientsPage />} />
        <Route path="enrollments" element={<EnrollmentsPage />} />
        <Route path="call-sessions" element={<CallSessionsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.MEDICAL_CENTERS} replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <MedicalCenterProvider>
          <CallSessionProvider>
            <AlertProvider>
              <AppRoutes />
              <CallSessionDetails />
            </AlertProvider>
          </CallSessionProvider>
        </MedicalCenterProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;